import config from '../../config.js';

const AnalyticsStatic = {
    trackers: {}
};

class Analytics {

    /** Add a new tracker
     *  provide settings object. This requires a type property indicating the type of tracker to use.
     */
    static addTracker(tracker){
        const trackerId = Math.round(99999 * Math.random());
        AnalyticsStatic.trackers[trackerId] = tracker;
        return trackerId;
    }

    static removeTracker(trackerId){
        if(AnalyticsStatic.trackers[trackerId]){
            AnalyticsStatic.trackers[trackerId].remove();
            delete AnalyticsStatic.trackers[trackerId];
            return true;
        }
        return false;
    }

    /*  Track a page view. You can provide details in the details object, or leave it empty to auto-populate
        it. Adding a trackerId is optional and allows you to target specific trackers. If the trackerId is
        omitted it will send the page view to all trackers.*/
    static trackPageView(details = {}, optionalTrackerId = null){
        let location = '';
        // When path is defined in details, we build the full location url.
        if(details.path && ! details.location){
            let root = config.root;
            if(! root.includes('://')){
                root = window.location.origin + root;
            }
            if(! root.endsWith('/')){
                root += '/';
            }
            location = root + (details.path.startsWith('/') ? details.path.substring(1) : details.path);
        }
        const settings = {
            title: details.title || document.title,
            location: details.location ? details.location : (location ? location : window.location.href),
            path: details.path || (window.location.pathname + window.location.hash)
        };
        if(optionalTrackerId !== null){
            AnalyticsStatic.trackers[optionalTrackerId].trackPageView(details);
            return;
        }

        for(const id of Object.keys(AnalyticsStatic.trackers)){
            AnalyticsStatic.trackers[id].trackPageView(settings);
        }
    }

    /*  Track an event. You can provide details in the details object. Adding a trackerId is optional and
        allows you to target specific trackers. If the trackerId is omitted it will send the page view to all
        trackers.*/
    static trackEvent(details = {}, optionalTrackerId = null){
        if(! details || ! details.action){
            console.error('Error sending analytics event. Required setting action is missing.');
            return;
        }
        const settings = {
            action: details.action,
            category: details.category || 'default category',
            label: details.label || 'no label',
            value: details.value || 1
        };
        if(optionalTrackerId !== null){
            AnalyticsStatic.trackers[optionalTrackerId].trackEvent(settings);
            return;
        }
        for(const id of Object.keys(AnalyticsStatic.trackers)){
            AnalyticsStatic.trackers[id].trackEvent(settings);
        }
    }
};

export {Analytics};
